import { defaultAxios, IParams } from '../base';

export interface IMutateHouseLoanExecute extends IParams {
    preRequestDtlNo: number;
    hopeConsultTimeCd: string;
}

// 고객 주담대 대출 상담 신청
export const mutateHouseLoanExecute = async (params: IMutateHouseLoanExecute) => {
    return await defaultAxios().put(`/house/loan/executeLoan`, params);
};
